(function($) {
    $.fn.scrollToThis = function (time, verticalOffset) {
        time = typeof (time) != 'undefined' ? time : 800;
        verticalOffset = typeof (verticalOffset) != 'undefined' ? verticalOffset : 0;
        const element = $(this);
        const offset = element.offset();
        const offsetTop = offset.top + verticalOffset;
        $('html, body').stop().animate({
            scrollTop: offsetTop
        }, time);
    };
})(jQuery);